export default "__VITE_ASSET__BLDd1a65__"